import { gql } from "@apollo/client";

const DRAFT_LIST_QUERY = gql`
  query drafts($archived: Boolean, $first: Int, $after: String, $last: Int, $before: String) {
    drafts(archived: $archived, first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          description
          created_on
          updated_on
          published_on
          status
          archived
          needs_merge
          branched_from
          created_by {
            name
            email
          }
          updated_by {
            name
            email
          }
          published_by {
            name
            email
          }
          flow_summary {
            purpose
            unfinished
            succeeded
            failed
            dirty_rows_all
            dirty_rows_some
          }
        }
      }
    }
  }
`;

const PUBLISHED_LIST_QUERY = gql`
  query published_draft {
    changelist {
      id
      description
      created_on
      updated_on
      published_on
      status
      created_by {
        name
        email
      }
      updated_by {
        name
        email
      }
      published_by {
        name
        email
      }
    }
  }
`;
export { DRAFT_LIST_QUERY, PUBLISHED_LIST_QUERY };
